import React from "react";
import { Link } from "react-router-dom";

const PgFOF = () => {
  return (
    <div>
      <div>404 not Found</div>
      <button>
        <Link to="/">Go Back</Link>
      </button>
    </div>
  );
};

export default PgFOF;
